<app-header class="header"></app-header>
<div class="container">
  <p-toast
    [breakpoints]="{ '5000px': { width: 'auto', right: '0' } }"
  ></p-toast>
  <router-outlet></router-outlet>
</div>
